<template>
  <v-dialog
    overlay-color="rgba(34, 34, 34, 0.27)"
    overlay-opacity="0.8"
    v-model="state"
    max-width="400"
    width="100%"
    persistent
  >
    <v-card>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addSenderID)">
          <v-card-title class="ft text-md">Create SMS Sender ID</v-card-title>

          <v-card-text>
            <v-container class="mt-n4">
              <ValidationProvider
                v-slot="{ errors }"
                rules="sender_id_required|sender_id_max:11"
              >
                <v-text-field
                  autofocus
                  :error-messages="errors[0]"
                  v-model="senderId.name"
                  class="ft font-weight-medium font-size-md"
                  label="Name of Sender ID"
                  hint="Provide sender id name here"
                />
              </ValidationProvider>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="accent"
              class="text-capitalize text-sm ft"
              text
              @click="action"
            >
              Cancel
            </v-btn>

            <v-btn
              :disabled="loading"
              :loading="loading"
              type="submit"
              color="primary"
              class="text-capitalize text-sm ft"
            >
              Save
            </v-btn>
          </v-card-actions>
        </form>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, max } from 'vee-validate/dist/rules';
/* Scoped rule names on purpose: vee-validate's extend() registers globally,
   so overriding `required`/`max` here rewrote the messages for every form in
   the app — a Sender ID field elsewhere was reporting "Name cannot be empty". */
extend('sender_id_required', {
  ...required,
  message: 'Name cannot be empty',
});
extend('sender_id_max', {
  ...max,
  message: 'Maximum sender id must be 11',
});
export default {
  name: 'AddSenderID',
  components: {
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    state: {
      type: Boolean,
      required: true,
    },
    loading: Boolean,
  },
  data: () => ({
    file: null,
    senderId: {
      name: '',
    },
  }),
  computed: {
    ...mapGetters({
      resetFormState: 'getResetFormState',
    }),
  },
  watch: {
    resetFormState(value) {
      if (value) {
        this.senderId = { name: '' };
      } else this.$store.dispatch('resetFormValues', false, { root: true });
    },
  },
  methods: {
    addSenderID() {
      this.$store.dispatch('sms/createSenderID', { ...this.senderId });
    },
    action() {
      this.$emit('actions', { idx: 'senderId', state: false });
    },
  },
};
</script>

<style scoped></style>
